var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"modalName":"variancesRegister","title":"REJESTR ROZBIEŻNOŚCI","buttons":[],"register":_vm.register},on:{"closed":_vm.close}},[_c('VariancesTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050cfada","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/start/modals/variances/VariancesRegister.vue
// module id = 2107
// module chunks = 0